import { TokenListMetadata } from "@bridgesplit/abf-sdk";

import { DerivedLoanEventActionType, ParsedLoanEventExpanded } from "../types";
import { isEventActionMetadataType } from "../utils";

export function getPastLoanCollateralMap(events: ParsedLoanEventExpanded[]): Map<string, number> | undefined {
    const sortedEvents = events.sort((a, b) => b.eventTime - a.eventTime);
    // Get add/remove collateral events for this specific mint
    const addEvents = sortedEvents.filter(
        (event) =>
            isEventActionMetadataType(event.actionMetadata, DerivedLoanEventActionType.AddCollateral) &&
            event.eventAssetMetadata?.mint
    );

    const removeEvents = sortedEvents.filter(
        (event) =>
            isEventActionMetadataType(event.actionMetadata, DerivedLoanEventActionType.RemoveCollateral) &&
            event.eventAssetMetadata?.mint
    );

    if (addEvents.length === 0) {
        return undefined;
    }

    const collateralBalances = new Map<string, { amount: number; metadata: TokenListMetadata }>();

    // Step 1: Add all deposits
    for (const event of addEvents) {
        const metadata = event.eventAssetMetadata;
        if (!metadata) continue;

        const mint = metadata.mint;
        const existing = collateralBalances.get(mint);

        if (existing) {
            existing.amount += event.amount;
        } else {
            collateralBalances.set(mint, {
                amount: event.amount,
                metadata
            });
        }
    }

    // Process remove events from newest to oldest, starting from the second to remove collateral event

    for (let i = 1; i < removeEvents.length; i++) {
        const event = removeEvents[i];
        const metadata = event.eventAssetMetadata;
        if (!metadata) continue;

        const mint = metadata.mint;

        const balance = collateralBalances.get(mint);
        if (balance) {
            balance.amount -= event.amount;
            if (balance.amount <= 0) {
                collateralBalances.delete(mint);
            }
        }
    }

    // If there are no collateral balances, return undefined
    if (collateralBalances.size === 0) {
        return undefined;
    }

    // Convert to the expected return type
    const result = new Map<string, number>();
    for (const [mintKey, { amount }] of collateralBalances.entries()) {
        result.set(mintKey, amount);
    }

    return result;
}
